export const numberWithEuroFormat = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-DE", {
    style: "currency",
    currency: "EUR",
  }).format(number);

  return formattedNumber;
};
